
<template>
  <a-modal
    title="编辑"
    :visible="true"
    centered
    @ok="submitEdit"
    @cancel="closeEdit"
    width="800px"
    :maskClosable="false"
  >
    <div class="lab-edit-form">
      <a-form-model
        ref="ruleForm"
        :model="detailsObj"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item ref="name" label="实验室名称" prop="name">
          <a-input v-model="detailsObj.name"
            @blur="
              () => {
                $refs.name.onFieldBlur();
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item
          :label-col="{span:4}"
          :wrapper-col="{span:9}"
          label="所在地"
          prop="regionCode"
        >
          <a-cascader 
            :options="cityData" 
            placeholder="请选择城市" 
            v-model="detailsObj.regionCode"
          />
        </a-form-model-item>
        <a-row>
          <a-col :span="3"></a-col>
          <a-col :span="8" style="margin-left: -9px;">
            <a-form-model-item label="状态">
              <a-radio-group v-model="detailsObj.canOrder">
                <a-radio :value="true">启用</a-radio>
                <a-radio :value="false">停用</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="7">
            <a-form-model-item label="首页展示" :label-col="{span: 8}" :wrapper-col="{span: 12}">
              <a-radio-group v-model="detailsObj.indexShow" >
                <a-radio :value="true">是</a-radio>
                <a-radio :value="false">否</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item ref="sort" label="排序" :label-col="{span: 8}" :wrapper-col="{span: 10}">
              <input v-model="detailsObj.sort" type="number" class="sortInput" :min="0"  >
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-form-model-item
          :label-col="{span:4}"
          :wrapper-col="{span:18}"
          label="实验室简介"
          prop="introduction"
        >
          <a-input
            type="textarea"
            placeholder="不超过150个字"
            v-model="detailsObj.introduction"
            :auto-size="{ minRows: 3, maxRows: 3 }"
          />
        </a-form-model-item>
        <a-form-model-item label="实验室LOGO" :label-col="{span:4}" :wrapper-col="{span:18}" prop="logo" >
          <div class="clearfix">
            <div v-if="detailsObj.logo" class="trademark-box">
              <img :src="detailsObj.logo" alt="图片" style="width:100%; height: 100%;">
              <div class="mask">
                <a-icon title="预览" type="eye" @click="previewImg"/>
                &nbsp;
                <a-icon title="删除"  type="delete" @click="delImg"/>
              </div> 
            </div>
            <a-upload
              class="folat-left"
              :action="doUpload"
              list-type="picture-card"
              :showUploadList="false"
              :headers="headers"
              :multiple="false"
              @change="handleChange"
              accept=".bmp,.gif,.jpg,.pic,.png,.jpeg"
              name="file"
              v-decorator="[
                'logo',
                { rules: [{ required: true, message: '请上传实验室LOGO' }], initialValue: detailsObj.logo}
              ]"
            >
              <div>
                <a-icon type="plus" />
                <div class="ant-upload-text">上传</div>
              </div>
            </a-upload>
            <a-modal :visible="isPreviewShow" :footer="null" @cancel="cancelPreview">
              <img alt="图片预览" style="width: 100%" :src="detailsObj.logo" />
            </a-modal>
          </div>
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>


<script>
import {
  editLaboratory,
  getLaboratorydDetails,
} from "@/api/laboratory";
import { getToken } from "@/utils/auth";

export default {
  name: 'labEditForm',
  props: {
    id: Number
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      logoId: 0,
      detailsObj: {
        id: undefined,
        name: '',
        canOrder: false,
        indexShow: false,
        sort: 0,
        introduction: '',
        logo: '',
        regionCode: []
      },
      rules: {
        name: [
          { required: true, message: '请输入实验室名称', trigger: 'blur' },
          { min: 1, max: 50, message: '实验室名称不能多于 50 字', trigger: 'blur' },
        ],
        introduction: [
          { required: true, message: '请输入实验室简介', trigger: 'change' },
          { min: 1, max: 150, message: '实验室简介不能多于 150 字', trigger: 'change' }
        ],
        logo: [{ required: true, message: '请上传实验室LOGO', trigger: 'blur' }],
        regionCode: [
          { type: 'array', required: true, message: '请选择实验室所在地', trigger: 'change', },
        ],
      },
      editForm: this.$form.createForm(this),
      doUpload: "/api/ossPublicConfig", //上传文件的api
      headers: {},
      region: [],
      canOrder: true,
      indexShow: false,
      sort: 0,
      cityData: this.$province,
      isPreviewShow: false,
    };
  },
  created() {
    this.init();
    this.getLaboratorydDetails(this.id);
  },
  mounted() {
  },
  methods: {
    handleSubmit(e) {
      console.log(this.formInline);
    },
    init() {
      let token = getToken();
      this.headers.Authorization = "Bearer " + token; //上传文件绑定Token  ie10以下不能使用
    },
    previewImg() {
      this.isPreviewShow = true;
    },
    cancelPreview() {
      this.isPreviewShow = false;
    },
    delImg() {
      this.detailsObj.logo = "";
      this.logoId = 0;
    },
    // ----------------------
    
    handleChange(data) {
      if (data.file.status == "done") {
        this.detailsObj.logo = data.file.response.attachmentUrl
        this.logoId = data.file.response.id
        this.$message.success("文件上传成功")
        this.$refs.ruleForm.clearValidate('logo')
      } else if (data.file.status == "error") {
        this.$message.error("文件上失败，请重新上传！")
      } else if (data.file.status == "removed") {
      }
    },
    // 提交表单
    submitEdit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
           try{
            let data = {
              id: this.detailsObj.id,
              canOrder: this.detailsObj.canOrder,
              indexShow: this.detailsObj.indexShow,
              sort: this.detailsObj.sort,
              logoId: this.logoId,
              region: `${this.detailsObj.regionCode[0]},${this.detailsObj.regionCode[1]}`,
              name: this.detailsObj.name,
              introduction: this.detailsObj.introduction
            }
            this.editLaboratory(data);
          }catch(err){
            console.log("err：",err);
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 获取实验室详情
    getLaboratorydDetails(id) {
      getLaboratorydDetails(id)
        .then((res) => {
          this.logoId = res.logo ? res.logo.id : 0
          this.detailsObj.id = res.id
          this.detailsObj.name = res.name
          this.detailsObj.canOrder = res.canOrder ? true : false
          this.detailsObj.indexShow = res.indexShow ? true : false
          this.detailsObj.sort = res.sort || 0
          this.detailsObj.introduction = res.introduction
          this.detailsObj.logo = res.logo ? res.logo.attachmentUrl : ''
          this.detailsObj.regionCode = res.regionCode ? res.regionCode.split(",") : []
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 编辑实验室
    editLaboratory(data) {
      editLaboratory(data)
        .then(res=>{
          this.$emit('hiddenAction');
        })
        .catch(error=>{
          console.log(error);
        })
    },
    // 关闭编辑页面
    closeEdit() {
      this.$emit('hiddenAction');
    },
  },
};
</script>
<style lang="less" scoped>
.lab-edit-form {
  .sortInput {
    border: 1px solid #eee;
    border-radius: 4px;
    width: 70px;
    height: 30px;
    text-align:center;
  }
  .folat-left {
    float: left!important;
    width: auto;
  }
  .trademark-box {
    position: relative;
    float: left;
    width: 102px;
    height: 102px;
    margin-right: 15px;
    vertical-align: middle;
    border: 1px dashed #f86d6d;
    border-radius: 4px;
    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(101, 101, 101, 0.6);
      color: #ffffff;
      opacity: 0;
      font-size: 24px;
      line-height: 102px;
      text-align: center;
    }
  }
  .trademark-box:hover {
    .mask {
      opacity: 1;
    }
  }
}
</style>
